import { RootState } from 'types'
import { Action } from 'redux/actions'

export default function reduce(
  state: RootState['categories'] = { records: [] },
  action: Action,
): RootState['categories'] {
  switch (action.type) {
    case 'CATEGORIES_SET': {
      const { categories } = action.payload
      return {
        ...state,
        records: categories,
      }
    }
    default:
      return state
  }
}
